import { string } from 'yup'
import { FieldTypes, HtmlInputTypes } from '../../../../models/form/IFieldsDefinition'
import { IncomeAdditionalFieldsNames } from '../../../../formDefinitions/IncomeInfoForm/IncomeInfoFields'
import { AdditionalIncomeAdditionalFieldsNames } from '../../../../formDefinitions/IncomeInfoForm/AdditionalIncomeFields'



export enum InputBooleanOptions {
   agree = "Tak",
   disagree = "Nie",
}

export type DropdownBooleanOptions = [
   { value: boolean; label: InputBooleanOptions.agree },
   { value: boolean; label: InputBooleanOptions.disagree }
]

export interface IDropdownBooleanOption {
   value: boolean;
   label: InputBooleanOptions;
}

export interface IDropdownOption {
   value: string | boolean,
   label: string
}

export interface IDropdownChangeIncomeFieldsOption { 
   label: string;
   value: string;
   fields: readonly IncomeAdditionalFieldsNames[] | readonly AdditionalIncomeAdditionalFieldsNames[]
}


export interface InputDropdownBaseProps{
   name: string;
   type: FieldTypes.dropdown;
   value: IDropdownOption;
   options: readonly IDropdownOption[]
   inputLabel: string;
   editable?: boolean;
   htmlInputType?: keyof typeof HtmlInputTypes;
   handleOnChange: (newValue: IDropdownOption) => void;
}


export interface InputDropdownBooleanProps extends Omit<InputDropdownBaseProps, 'type' | 'options' | 'handleOnChange' | 'value'>{
   type: FieldTypes.boolean;
   value: IDropdownBooleanOption;
   options: DropdownBooleanOptions;
   handleOnChange: (newValue: IDropdownBooleanOption) => void;
}

export interface InputDropdownChangeIncomeTypeFieldProps extends Omit<InputDropdownBaseProps, 'type' | 'options' | 'handleOnChange' | 'value'>{
   type: FieldTypes.dropdownChangeIncomeTypeField;
   value: IDropdownChangeIncomeFieldsOption;
   options: readonly IDropdownChangeIncomeFieldsOption[];
   handleOnChange: (newValue: IDropdownChangeIncomeFieldsOption) => void;
}

export interface IDialogAutocompleteMobileMenuProps {
   children: React.ReactNode;
   isMenuOpen: boolean;
   inputLabel: string;
   handleOnMenuClose: () => void;
}

export interface IInputDropdownInputProps {
   isMobileDevice: boolean;
   name: string;
   inputProps: React.InputHTMLAttributes<HTMLInputElement>;
   inputRef: React.Ref<any>;
   handleToggleMenuOpen: () => void;
}

// export type InputDropdownProps = InputDropdownBaseProps | InputDropdownActionOnChengeProps;
export type InputDropdownProps = InputDropdownBaseProps | InputDropdownBooleanProps | InputDropdownChangeIncomeTypeFieldProps